"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.versions = void 0;
;
exports.versions = {
  version: '3.0.1',
  name: 'lingo2-models',
  versionDate: '2025-05-20T05:42:04.716Z',
  description: 'Shared models library',
  gitCommitHash: 'g0b31605',
  gitCommitDate: '2025-05-20T05:40:43.000Z',
  versionLong: '3.0.1-g0b31605',
  gitTag: 'v2.0.34'
};
exports.default = exports.versions;
